import{asChildPropDef as o}from"../props/as-child.prop.js";const s={...o},t={...o};import{baseTabListPropDefs as a}from"./base-tab-list.props.js";export{t as tabsContentPropDefs,a as tabsListPropDefs,s as tabsRootPropDefs};
//# sourceMappingURL=tabs.props.js.map
